import { parseCookieValue } from "@tm/isomorphic-utils";
import type { AxiosRequestHeaders } from "axios";

function getHost(headers: any) {
  let goibiboHost = process.env["MOCK_HOST"] || headers?.["x-goibibo-host"];
  if (goibiboHost && goibiboHost.includes("goibibo")) {
    goibiboHost = "www.goibibo.com";
  }
  return goibiboHost || headers?.["x-forwarded-host"] || headers?.["host"];
}

const MOBILE_RE =
  /(mobi|iphone|ipod|android.*mobile|windows phone|blackberry)/i;

function getDeviceFromHeaders(
  headers: Record<string, unknown>
): "mobile" | "desktop" {
  const mobileDevice = headers["mobile-device"];
  if (mobileDevice === "true" || headers["app-version"]) return "mobile";
  if (mobileDevice === "false") return "desktop";

  const ua = (headers["user-agent"] as string) || "";
  return MOBILE_RE.test(ua) ? "mobile" : "desktop";
}

export function enhanceRequestHeaders(
  headers?: AxiosRequestHeaders
): AxiosRequestHeaders {
  const {
    cookie = "",
    "mmt-auth": mmtAuth,
    "OAUTH-GOIBIBO": oauthGoibibo,
    cmp,
    dvid,
    "device-id": device_id,
    ...restHeaders
  } = headers || {};

  const resolvedMmtAuth =
    mmtAuth || parseCookieValue(cookie as string, "mmt-auth");
  const resolvedOauthGoibibo =
    oauthGoibibo || parseCookieValue(cookie as string, "OAUTH-GOIBIBO");

  const goMmtHost = getHost(headers);
  const x_tm_device = headers?.["x-tm-device"] || getDeviceFromHeaders(
    (headers || {}) as Record<string, unknown>
  );

  if (typeof cmp === "string" && cmp != "") {
    return {
      cmp,
      cookie,
      "x-tm-device": x_tm_device,
      "X-Tm-Client": "desktop",
      "device-id": dvid || device_id || "",
      "Content-Type": "application/json",
      ...(resolvedMmtAuth ? { "mmt-auth": resolvedMmtAuth } : {}),
      ...(resolvedOauthGoibibo
        ? { "OAUTH-GOIBIBO": resolvedOauthGoibibo }
        : {}),
      ...(headers?.["x-ins-gommt-host"] || goMmtHost
        ? { "x-ins-gommt-host": headers?.["x-ins-gommt-host"] || goMmtHost }
        : {}),
    };
  }

  return {
    cookie,
    "x-tm-device": x_tm_device,
    "X-Tm-Client": "desktop",
    "device-id": dvid || device_id || "",
    "Content-Type": "application/json",
    ...(resolvedMmtAuth ? { "mmt-auth": resolvedMmtAuth } : {}),
    ...(resolvedOauthGoibibo ? { "OAUTH-GOIBIBO": resolvedOauthGoibibo } : {}),
    ...(headers?.["x-ins-gommt-host"] || goMmtHost
      ? { "x-ins-gommt-host": headers?.["x-ins-gommt-host"] || goMmtHost }
      : {}),
  };
}
